import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, Sparkles, HeartHandshake, ArrowRight } from "lucide-react";

export default function CompleteProfile() {
  const nav = useNavigate();

  return (
    <div className="kupidon-shell safe-top safe-bottom flex flex-col relative">
      <div className="flex-1 px-6 py-10 flex flex-col items-center justify-center text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.85 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.4 }}
          className="w-16 h-16 rounded-3xl bg-gradient-to-br from-[color:var(--peach)] to-[color:var(--peach-deep)] flex items-center justify-center shadow-lg shadow-[#E76F51]/25 mb-6"
        >
          <CheckCircle2 className="w-8 h-8 text-white" strokeWidth={2.2} />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1, duration: 0.5 }}
          className="font-[Onest] font-extrabold text-3xl tracking-tight"
        >
          Готово, ты в Kupidon!
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="mt-3 text-[color:var(--ink-soft)] text-[15px] leading-relaxed max-w-[30ch]"
        >
          Анкета уже видна другим. Заполни её подробнее, когда будет минутка, — это не займёт много времени.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
          className="mt-8 w-full space-y-3 text-left"
        >
          <div className="rounded-2xl bg-white/70 border border-[color:var(--border)] p-4 flex items-start gap-3">
            <div className="w-9 h-9 rounded-xl bg-[color:var(--peach)]/12 text-[color:var(--peach-deep)] flex items-center justify-center flex-shrink-0">
              <Sparkles className="w-4 h-4" />
            </div>
            <div className="text-sm">
              <div className="font-semibold">Точнее совместимость</div>
              <div className="text-[color:var(--ink-soft)] text-[13px] mt-0.5">
                Мировоззрение, дети, привычки — всё это участвует в расчёте, насколько вы подходите друг другу.
              </div>
            </div>
          </div>
          <div className="rounded-2xl bg-white/70 border border-[color:var(--border)] p-4 flex items-start gap-3">
            <div className="w-9 h-9 rounded-xl bg-[color:var(--peach)]/12 text-[color:var(--peach-deep)] flex items-center justify-center flex-shrink-0">
              <HeartHandshake className="w-4 h-4" />
            </div>
            <div className="text-sm">
              <div className="font-semibold">Больше доверия</div>
              <div className="text-[color:var(--ink-soft)] text-[13px] mt-0.5">
                Анкета с деталями выглядит живее и получает больше внимания, чем пустая.
              </div>
            </div>
          </div>
        </motion.div>
      </div>

      <div className="px-6 pb-6 space-y-2">
        <button
          data-testid="complete-profile-cta"
          onClick={() => nav("/profile", { replace: true })}
          className="btn-pill w-full bg-[color:var(--peach)] text-white flex items-center justify-center gap-2"
        >
          Заполнить профиль
          <ArrowRight className="w-4 h-4" />
        </button>
        <button
          data-testid="complete-profile-skip"
          onClick={() => nav("/discover", { replace: true })}
          className="btn-pill w-full bg-transparent text-[color:var(--ink-soft)]"
        >
          Пропустить, сделаю позже
        </button>
      </div>
    </div>
  );
}
